import { ExchangeTokenParams, ExchangeTokenResponse } from "./types";
import { ContextInstance, ContextManager } from "~/modules/contextManager/ContextManager";
import { SsoSetupServiceImpl } from "~/backend/generated/SSOSetup/api/ssoSetup.service";
import type { TokenExchangeRequestBody } from "~/backend/generated/SSOSetup/model/tokenExchangeRequestBody";

export const exchangeToken =
    (ctx: ContextManager) =>
    async (options: ExchangeTokenParams): Promise<ExchangeTokenResponse> => {
        const ssoSetupService = ctx.retrieveInstanceOf(ContextInstance.SsoSetupServiceImpl, SsoSetupServiceImpl);
        const requestBody: TokenExchangeRequestBody = {
            ssoProfileSid: (!options.isConsoleLogin && options.ssoProfileSid) || undefined,
            accountSid: options.isConsoleLogin ? options.accountSid : undefined,
            instanceSid: options.isConsoleLogin ? options.instanceSid : undefined,
            appType: options.appType,
            isConsoleLogin: options.isConsoleLogin,
            code: options.code,
            codeVerifier: options.codeVerifier,
            nonce: options.nonce,
            grantType: "AuthorizationCode"
        };

        return ssoSetupService.generateOauthTokens(requestBody);
    };
